import ZoomableMap from "./ZoomableMap";

export default ZoomableMap;
